export class QatarService {
    welcome() {
        return 'welcome to ApiService';
    }
    checkPassionPoints(): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                let response = await fetch('/status/passion-point')
                resolve(response)

            } catch (error) {
                reject(error)
            }
        })
    }
    checkEmail(email: string): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                let response = await fetch(`/api/validateEmail/${email}`)
                resolve(response)
            } catch (error) {
                reject(error)
            }
        })
    }
    checkPhone(phone: string): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                let response = await fetch(`/api/validatePhone/${phone}`)
                resolve(response)
            } catch (error) {
                reject(error)
            }
        })
    }
    validateLogin(email: string, pass: string): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                let data = {e:email,p:pass};
                let response = await fetch("/api/validateLogin", {
                    method: "POST",
                    headers: {'Content-Type': 'application/json'}, 
                    body: JSON.stringify(data)
                }).then(res => resolve(res.json()))
                // resolve(response)
            } catch (error) {
                reject(error)
            }
        })
    }
    newPass(pass: string): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                let data = {p:pass};
                let response = await fetch("/api/budCatarUser", {
                    method: "POST",
                    headers: {'Content-Type': 'application/json'}, 
                    body: JSON.stringify(data)
                }).then(res => resolve(res.json()))
                // resolve(response)
            } catch (error) {
                reject(error)
            }
        })
    }
    resetPass(email: string): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                let data = {e:email};
                let response = await fetch("/api/resetPass", {
                    method: "POST",
                    headers: {'Content-Type': 'application/json'}, 
                    body: JSON.stringify(data)
                }).then(res => resolve(res.json()))
                // resolve(response)
            } catch (error) {
                reject(error)
            }
        })
    }
}